import { RemissionDetailPrintModel } from "./remission-detail-print.model";

export class RemissionPrintModel {
  remissionId: number = 0;
  companyId: number = 0;
  enterpriseId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseNit: string = '';
  enterpriseName: string = '';
  branchId: number = 0;
  branchCode: string = '';
  branchName: string = '';
  address: string = '';
  phone: string = '';
  consecutive: string = '';
  dateRemission: Date = new Date();
  dateInvoice: Date = new Date();
  costCenterCodeName: string = '';
  constructionSiteAddress: string = '';
  constructionSitePhone: string = '';
  constructionSiteAlterPhone: string = "";
  clientDocumentName: string = '';
  destinityDepartment: string = '';
  destinityCity: string = '';
  wildcard: string | null = null;
  wildcard2: string | null = null;
  printObservation: string = '';
  remissionObservation: string = '';
  transporterName: string = '';
  transportValue: number = 0;
  remissionDetails: RemissionDetailPrintModel[] = [];
}